import React, { useState, useEffect, useMemo } from 'react';
import { PERFORMANCE_CONFIG } from '../utils/performance';

// Import all slideshow images
import slide1 from '../assets/BornFreeStem-1.webp';
import slide2 from '../assets/BornFreeStem-2.webp';
import slide3 from '../assets/BornFreeStem-3.webp';
import slide4 from '../assets/BornFreeStem-4.webp';
import slide5 from '../assets/BornFreeStem-5.webp';
import slide6 from '../assets/BornFreeStem-6.webp';
import slide7 from '../assets/BornFreeStem-7.webp';
import slide8 from '../assets/BornFreeStem-8.webp';
import slide9 from '../assets/BornFreeStem-9.webp';
import slide10 from '../assets/BornFreeStem-10.webp';
import slide11 from '../assets/BornFreeStem-11.webp';
import slide12 from '../assets/BornFreeStem-12.webp';
import slide13 from '../assets/BornFreeStem-13.webp';
import slide14 from '../assets/BornFreeStem-14.webp';

const AnimatedSlideshow: React.FC = () => {
  const images = useMemo(() => [slide1, slide2, slide3, slide4, slide5, slide6, slide7, slide8, slide9, slide10, slide11, slide12, slide13, slide14], []);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
    }, PERFORMANCE_CONFIG.ANIMATED_SLIDESHOW_INTERVAL); // Change image every 400ms - balanced speed

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="relative" style={{ width: '300px', height: '300px' }}>
      {/* Simple image display with circular mask */}
      <div className="absolute inset-0 rounded-full overflow-hidden">
        <img 
          src={images[currentIndex]} 
          alt={`BornFreeStem-${currentIndex + 1}`}
          className="w-full h-full object-cover transition-all duration-200"
          style={{ 
            transform: `rotate(${currentIndex * 25.7}deg) scale(${0.9 + (currentIndex % 3) * 0.05})`,
          }}
          onError={(e) => {
            console.error('Failed to load image:', `BornFreeStem-${currentIndex + 1}`);
            console.error('Image path:', images[currentIndex]);
          }}
        />
      </div>
      
      {/* Outer glow effect */}
      <div 
        className="absolute inset-0 rounded-full opacity-40 pointer-events-none"
        style={{
          boxShadow: '0 0 20px rgba(135, 206, 235, 0.6), 0 0 40px rgba(255, 255, 255, 0.3)',
          transform: `scale(${1.1 + Math.sin(currentIndex * 0.3) * 0.05})`,
        }}
      />
    </div>
  );
};

export default AnimatedSlideshow; 